import {
  analyticsDataRegistry,
  makeEventDetail,
  trackNavigationEvent,
  trackProductPageLoad,
  trackPromotionEvent,
  TrackingPageSection,
  TrackingPageStage,
} from '@vp/digital-tracking-lib';

const { websShutdown, wixMySites, wixDomainsSearchResults, wixDomains } =
  analyticsDataRegistry;

export const GWS_PROMO_ID = 'gwsBanner:Webs Shut Down';
export const GWS_PROMO_CREATIVE = 'Gws Promo Banner';
export const GWS_BANNER_NAME = 'gwsBanner';
export const GWS_BANNER_POSITION = 'Webs Shut Down Promo Banner';

const gwsTrackingSpec: [
  string, // promo ID
  string, // creative
  string, // name
  string, // position
  TrackingPageSection, // pageSection
  TrackingPageStage, // pageStage
  string // pageName
] = [
  GWS_PROMO_ID, //promo ID
  GWS_PROMO_CREATIVE, //creative
  GWS_BANNER_NAME, //name
  GWS_BANNER_POSITION, //position
  websShutdown.pageSection,
  websShutdown.pageStage, //stage
  websShutdown.pageName, //pageName
];
// Fires a product page load event, and a product viewed event
export function trackWebsShutdownPageLoad(): void {
  trackProductPageLoad(websShutdown);
  trackPromotionEvent('Promotion Viewed', ...gwsTrackingSpec);
}
export function getTrackingAssetName(): string {
  const trackingAssetName = websShutdown.trackingAssetName;

  return trackingAssetName;
}

export const DOMAINS_MAIN_HERO_LABEL = 'Content:Webs Shutdown Domains Sub Hero';
export const DOMAINS_MAIN_HERO_PAGE_ZONE = 'Webs Shutdown Domains Sub Hero';
export const CONNECT_A_DOMAIN_I_OWN_CTA_DETAIL =
  'Connect a Domain I already own';
export const DOMAINS_MERCHANDISING_SECTION_LABEL =
  'Content:Merchandising Section';
export const DOMAINS_MERCHANDISING_SECTION_PAGE_ZONE = 'Merchandising Section';
export const FIND_MY_DOMAIN_CTA = 'Find my domain';

export const WEBSITE_MAIN_HERO_LABEL = 'Content:Websites Main Hero';
export const HERO_PRETITLE_LABEL = 'Content:Hero Pretitle';
export const KEY_BENEFITS_LABEL = 'Content:Key Benefits Section';
export const GO_TO_VISTAPRINT_LABEL = 'Content:Go to Vistaprint section';
export const CREATE_A_FREE_VISTA_WIX_WEBSITE = 'Create a Free Website';
export const GO_TO_VISTAPRINT = 'Go to Vistaprint.com';

enum WebsitesPageZones {
  FollowingServices = 'Following Services Section',
  WebsitesMainHero = 'Websites Main Hero',
  GoToVistaprint = 'Go to Vistaprint.com Section',
  HeroPretitle = 'Hero Pretitle',
  KeyBenefits = 'Key Benefits Section',
}
const NAVIGATION_CLICKED_ACTION = 'Navigation Clicked';

export function trackCreateFreeVistaWixWebsiteMainCTAClick(
  destinationUrl: string
) {
  websShutdown.pageUri = destinationUrl;
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    WEBSITE_MAIN_HERO_LABEL,
    websShutdown, //source
    wixMySites, //target
    WebsitesPageZones.WebsitesMainHero,
    CREATE_A_FREE_VISTA_WIX_WEBSITE
  );
}
export function trackCreateFreeVistaWixWebsiteHeroPretitleCTAClick(
  destinationUrl: string
) {
  websShutdown.pageUri = destinationUrl;
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    HERO_PRETITLE_LABEL,
    websShutdown, //source
    wixMySites, //target
    WebsitesPageZones.HeroPretitle,
    CREATE_A_FREE_VISTA_WIX_WEBSITE
  );
}
export function trackCreateFreeVistaWixWebsiteKeyBenefitsCTAClick(
  destinationUrl: string
) {
  websShutdown.pageUri = destinationUrl;
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    KEY_BENEFITS_LABEL,
    websShutdown, //source
    wixMySites, //target
    WebsitesPageZones.KeyBenefits,
    CREATE_A_FREE_VISTA_WIX_WEBSITE
  );
}
export function trackWixConnectDomainsCTAClick(destinationUrl: string) {
  const wixDestinationDomains = {
    pageUri: destinationUrl.split('?')[0],
  };
  // Navigates to wix domains page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    DOMAINS_MAIN_HERO_LABEL,
    websShutdown, //source
    wixDestinationDomains, //target
    DOMAINS_MAIN_HERO_PAGE_ZONE,
    CONNECT_A_DOMAIN_I_OWN_CTA_DETAIL
  );
}

export function trackWixFindMyDomainCTAClick(destinationUrl: string) {
  wixDomainsSearchResults.pageUri = destinationUrl.split('?')[0];
  // Navigates to wix domain search page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    DOMAINS_MERCHANDISING_SECTION_LABEL,
    websShutdown, //source
    wixDomainsSearchResults, //target
    DOMAINS_MERCHANDISING_SECTION_PAGE_ZONE,
    FIND_MY_DOMAIN_CTA,
    {
      eventDetail: makeEventDetail(
        wixDomains.pageUri,
        wixDomainsSearchResults.pageUri,
        DOMAINS_MERCHANDISING_SECTION_PAGE_ZONE,
        FIND_MY_DOMAIN_CTA
      ),
    }
  );
}

export function trackGwsPromotionClick() {
  trackPromotionEvent('Promotion Clicked', ...gwsTrackingSpec);
}
